import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, Row, Col, Nav } from 'react-bootstrap';

import StoryblokImage from '../../internal/storyblokImage/StoryblokImage';
import LanguageSelector from '../languageSelector/LanguageSelector';
import SiteSocialLinks from '../siteSocialLinks/SiteSocialLinks';
import RioLog from '../../../../static/images/rt_2022_primary_red_rgb.svg';
import useSiteSettings from '../../../hooks/useSiteSettings';
import './Footer.scss';

const Footer = ({ navigation, lang }) => {
  const settings = useSiteSettings(lang);

  const { copywrite, footer_title, terms_conditions, privacy_policy, cookie_settings_link, language_selector, logo } =
    settings || {};

  return (
    <footer className='footer'>
      <Container>
        <Row className='footer-container'>
          <Col xs='12' className='footer-logo'>
            {/* <Col xl="2"> */}
            <a href={lang === 'en' ? '/' : `/${lang}`}>
              <StoryblokImage sbImageData={logo} />
            </a>
          </Col>
          <Col xs='12'>
            {/* <Col xl="3"> */}
            <p className='footer-title'>{footer_title}</p>
          </Col>
          <Col xl='5' lg='6' md='12' className='footer-nav-column'>
            <Nav className='justify-content-center'>
              {navigation.map((navItem, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    href={!navItem.customPath ? navItem.path : navItem.customPath}
                    key={index}
                    className='footer-nav-item'
                  >
                    {!navItem.menuCaption ? navItem.name : navItem.menuCaption}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          <Col xl='2' lg='6' md='12' className='footer-lang-column'>
            <div className='footer-lang'>
              <LanguageSelector language_selector={language_selector} lang={lang} withStyle={{ margin: 'auto 0px' }} />
              <SiteSocialLinks settings={settings} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl='6' lg='6' md='12'>
            <p>
              Copyright © {new Date().getFullYear()}. {copywrite}
            </p>
          </Col>
          <Col xl='5' lg='5' md='6' sm='12' className='terms-and-policy-col'>
            <Nav className='justify-content-end terms-and-policy'>
              <Nav.Item>
                <Nav.Link href={terms_conditions && terms_conditions.url ? terms_conditions.url : ''}>
                  <FormattedMessage id='component.global.footer.terms_conditions' />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={privacy_policy && privacy_policy.url ? privacy_policy.url : ''}>
                  <FormattedMessage id='component.global.footer.privacy_policy' />
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link href={cookie_settings_link && cookie_settings_link.url ? cookie_settings_link.url : ''}>
                  <FormattedMessage id='component.global.footer.cookie_settings' />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col xl='1' lg='1' md='6' sm='12' className='justify-content-end rio-logo'>
            <img src={RioLog} alt='Rio Tinto' width='80px' height='30px' style={{ maxWidth: '80px' }} />
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
